/* =================================================================
   Traditional Zürich — Layout- und Interaktions-Helfer
   SEO-Paket 2 (2026-09)
   - ersetzt vier bisher inline im Dokument wiederholte Skriptblöcke
     (Streifen-Killer, Advisor-Trigger, FAQ)
   - lädt advisor.js (37 kB) + tzh-config.js erst beim ersten Klick auf
     "Beratung starten". Vorher wurden sie auf jedem Startseiten-Aufruf
     geparst und ausgeführt, obwohl die wenigsten den Berater öffnen.
   ================================================================= */
(function () {
  'use strict';

  // --- Weissraum über der ersten Section killen ---------------------
  function killWhitespace() {
    try {
      var b = document.body, h = document.documentElement;
      ['margin-top', 'padding-top'].forEach(function (p) {
        b.style.setProperty(p, '0', 'important');
        h.style.setProperty(p, '0', 'important');
      });
      var main = document.getElementById('MainContent');
      if (main) {
        ['margin-top', 'padding-top'].forEach(function (p) { main.style.setProperty(p, '0', 'important'); });
        var first = main.firstElementChild;
        if (first) ['margin-top', 'padding-top'].forEach(function (p) { first.style.setProperty(p, '0', 'important'); });
      }
      ['cart-drawer', 'cart-notification', 'predictive-search'].forEach(function (tag) {
        document.querySelectorAll(tag).forEach(function (el) {
          el.style.setProperty('position', 'fixed', 'important');
          el.style.setProperty('top', '0', 'important');
        });
      });
    } catch (e) {}
  }

  // --- Advisor: erst auf Anforderung laden ---------------------------
  var advisorState = 'idle'; // idle | loading | ready

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }

  function ensureAdvisor() {
    if (advisorState !== 'idle') return Promise.resolve();
    advisorState = 'loading';
    var cfg = document.documentElement.getAttribute('data-tzh-advisor-config');
    var adv = document.documentElement.getAttribute('data-tzh-advisor-src');
    if (!cfg || !adv) { advisorState = 'idle'; return Promise.reject(); }
    return loadScript(cfg)
      .then(function () { return loadScript(adv); })
      .then(function () { advisorState = 'ready'; });
  }

  function openAdvisor(e) {
    var btn = e.target.closest('[data-action="open-advisor"]');
    if (!btn) return;
    e.preventDefault();

    if (window.Advisor && typeof window.Advisor.open === 'function') {
      window.Advisor.open();
      return;
    }

    ensureAdvisor().then(function () {
      var tries = 0;
      var iv = setInterval(function () {
        if (window.Advisor && typeof window.Advisor.open === 'function') {
          clearInterval(iv);
          window.Advisor.open();
        } else if (++tries > 40) {
          clearInterval(iv);
          fallbackScroll();
        }
      }, 75);
    }).catch(fallbackScroll);
  }

  function fallbackScroll() {
    var target = document.getElementById('advisor-start');
    if (target) target.scrollIntoView({ behavior: 'smooth' });
  }

  // --- FAQ-Akkordeon ------------------------------------------------
  function toggleFaq(e) {
    var q = e.target.closest('.faq__q');
    if (q && q.parentElement) q.parentElement.classList.toggle('is-open');
  }

  function boot() {
    killWhitespace();
    if (!window.__TZH_LAYOUT_BOUND__) {
      window.__TZH_LAYOUT_BOUND__ = true;
      document.addEventListener('click', openAdvisor);
      document.addEventListener('click', toggleFaq);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', killWhitespace);
})();